export default __webpack_public_path__ + "static/media/kuwaitinput.d1e106e8.svg";